module.exports = __webpack_public_path__ + "img/149.753b9b92.gif";